import { render, staticRenderFns } from "./filter-drawer.vue?vue&type=template&id=6808cb98"
import script from "./filter-drawer.vue?vue&type=script&lang=js"
export * from "./filter-drawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports